/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListCompanySubscriptionsCompanySubscriptionDtoFromJSON, ListCompanySubscriptionsCompanySubscriptionDtoToJSON, } from './ListCompanySubscriptionsCompanySubscriptionDto.js';
/**
 * Check if a given object implements the ListCompanySubscriptionsResult interface.
 */
export function instanceOfListCompanySubscriptionsResult(value) {
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
export function ListCompanySubscriptionsResultFromJSON(json) {
    return ListCompanySubscriptionsResultFromJSONTyped(json, false);
}
export function ListCompanySubscriptionsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'results': (json['results'].map(ListCompanySubscriptionsCompanySubscriptionDtoFromJSON)),
    };
}
export function ListCompanySubscriptionsResultToJSON(json) {
    return ListCompanySubscriptionsResultToJSONTyped(json, false);
}
export function ListCompanySubscriptionsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'results': (value['results'].map(ListCompanySubscriptionsCompanySubscriptionDtoToJSON)),
    };
}
